import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
})

export class MailFetchAPI {

    //Function to get business by code 
    static async sendMail(data, token) {
        const res = await server(`/mail`, {
            method: "post",
            data: data,
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res
    }

}